import Popups from '@/components/popup/components/enums.ts';
import Modals from '@/components/modal/components/enums.ts';

export function useAllModals() {
  const { openPopup } = usePopups();
  const { openModal } = useModals();
  const openError = (props: any) => {
    openPopup(Popups.error.component, { ...Popups.error.props, ...props });
  };

  const openCheckout = (props: any) => {
    openModal(Modals.checkout.component, { ...Modals.checkout.props, ...props });
  };

  const openNewCheckout = (props?: any) => {
    openModal(Modals.newCheckout.component, { ...Modals.newCheckout.props, ...props });
  };

  const openChangeEmail = (props: any) => {
    openModal(Modals.changeEmail.component, { ...Modals.changeEmail.props, ...props });
  };

  const openSkipTrial = (props: any) => {
    openModal(Modals.skipTrial.component, { ...Modals.skipTrial.props, ...props });
  };

  const openExpiredOfferModal = (props: any) => {
    openModal(Modals.expiredOffer.component, { ...Modals.expiredOffer.props, ...props });
  };

  const choosePriceModal = (props: any) => {
    openModal(Modals.trialPrice.component, { ...Modals.trialPrice.props, ...props });
  };

  const trialGuaranteeModal = (props: any) => {
    openModal(Modals.trialGuarantee.component, { ...Modals.trialGuarantee.props, ...props });
  };

  const openUpgradeModal = (props: any) => {
    openModal(Modals.upgradeModal.component, { ...Modals.upgradeModal.props, ...props });
  };

  return {
    openError,
    openCheckout,
    openChangeEmail,
    openSkipTrial,
    openExpiredOfferModal,
    choosePriceModal,
    trialGuaranteeModal,
    openNewCheckout,
    openUpgradeModal,
  };
}
